<!--
  -  Filename........: Magento1List.vue
  -  Project.........: logistik-app
  -  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
  -  @version........: 1.0
  -
  -  @since..........: 22.07.20, 14:06
  -  @author.........: Robin Rick
  -
  -  @brief..........:
  -->

<template>
  <v-app>
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="panel panel-default">
            <div class="panel-heading">{{ $t('magento1connector.shop.header') }}</div>
            <div class="panel-body">
              <table class="table table-responsive">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>{{ $t('magento1connector.shop.department') }}</th>
                  <th>{{ $t('magento1connector.shop.active') }}</th>
                  <th>{{ $t('magento1connector.shop.url') }}</th>
                  <th>{{ $t('magento1connector.shop.created') }}</th>
                  <th>{{ $t('magento1connector.shop.config') }}</th>
                  <th>{{ $t('magento1connector.shop.delete') }}</th>
                </tr>
                </thead>
                <tbody v-if="shops.length">
                <tr v-for="shop in shops">
                  <td>{{ shop.id }}</td>
                  <td>{{ shop.department.name }}</td>
                  <td v-if="shop.active"><i class="glyphicon glyphicon-ok"></i></td>
                  <td v-else><i class="glyphicon glyphicon-remove"></i></td>
                  <td>{{ shop.host_url }}</td>
                  <td>{{ shop.created_at }}</td>
                  <td><i class="glyphicon glyphicon-share-alt"
                         @click="showModal(shop.id)"></i></td>
                  <td><a href="#" class="btn btn-link btn-danger" @click="deleteShop(shop.id)"><i
                      data-id=""
                      class="glyphicon glyphicon-trash"></i></a>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="pull-right">
                <button class="btn btn-success glyphicon-plus" @click="$refs.modal.show()"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <modal ref="modal" :title="((this.modalId)?$t('magento1.label.edit'):$t('magento1.label.create'))">
        <magento-1-edit-create ref="edit" :id="modalId"></magento-1-edit-create>
      </modal>
    </div>
  </v-app>
</template>

<script>
import magento1service from "../services/magento1service";

export default {
  name: "Magento1List",
  data() {
    return {
      shops: [],
      modalId: null
    }
  },
  methods: {
    getShops: function () {
      magento1service.getAll().then(
          (response) => {
            this.shops = response
          }
      );
    },
    showModal: function (id) {
      this.modalId = id;
      this.$refs.modal.show()
    },
    deleteShop: function (id) {
      let confirmed = confirm(this.$t('magento1.confirmDelete'));
      if (confirmed) {
        magento1service.delete(id).then(
            (response) => {
              this.getShops();
            }
        );
      }
    }
  },
  mounted() {
    this.getShops();
    this.$eventBus.$on('magento1-created-updated', () => {
      this.$refs.modal.hide();
      this.getShops();
    });
  }
}
</script>

<style scoped>

</style>